import { render, staticRenderFns } from "./TraderReportTable.vue?vue&type=template&id=d18ae722&scoped=true"
import script from "./TraderReportTable.vue?vue&type=script&lang=js"
export * from "./TraderReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18ae722",
  null
  
)

export default component.exports